import React from 'react'
import ModalWrapper from '../../common/Modal/ModalWrapper'

const FractionHelpClientModal = ({ helpClientModal }) => {
    let image = ''
    if (helpClientModal === 'reduce') image = require('../../../../images/fractional/helpClient/1.svg')
    if (helpClientModal === 'systematically') image = require('../../../../images/fractional/helpClient/5.svg')
    if (helpClientModal === 'maximise') image = require('../../../../images/fractional/helpClient/3.svg')

    let rightImage = ''
    if (helpClientModal === 'reduce') rightImage = require('../../../../images/fractional/helpClient/left.png')
    if (helpClientModal === 'systematically') rightImage = require('../../../../images/fractional/helpClient/center.png')
    if (helpClientModal === 'maximise') rightImage = require('../../../../images/fractional/helpClient/right.png')
    const data = {
        'reduce': {
            title: <h3 className='fs1-5rem c15 fw600'>Turn a Disorganized Client into a <br></br> Strategic Win</h3>,
            description: <div className='pr2rem'>
                <p className='c74 fs1rem mb1rem mt1rem'>A new, disorganized client is your biggest opportunity to demonstrate immediate value. Here’s the playbook: </p>
                <ul
                    style={{
                        listStyleType: 'decimal',
                        paddingLeft: '20px'
                    }}
                >
                    <li className='c74 mb1rem'>
                        <span className='fw600 mr0-5rem'>
                            Diagnose & Organize with AI :
                        </span>
                        Instantly identify risks with our Business Audit. Then, let Clarence, our AI assistant, help you build a professional data repository in a fraction of the time.
                    </li>
                    <li className='c74 mb1rem'>
                        <span className='fw600 mr0-5rem'>
                            Build a Complete Diligence Pack:
                        </span>
                        Generate a full suite of ResearchAid reports and complete key documents like Directors' Questionnaires and Warranty Disclosures to impress investors from the start.
                    </li>
                    <li className='c74 mb1rem'>
                        <span className='fw600 mr0-5rem'>
                            Connect via InvestMatch:
                        </span>
                        Use our OneForm for 1-click introductions to suitable investors, offering them your pre-diligenced pack to boost confidence and accelerate the conversation.
                    </li>
                </ul>
            </div>,
            testimonial: "Step by step help with a helicopter view",
            author: 'SN, Fractional CFO',
        },
        'systematically': {
            title: <h3 className='fs1-5rem c15 fw600'>Systematically Boost Client Value,<br></br> and Your Own</h3>,
            testimonial: `It give me a way to upsell into clients`,
            description: <>
                <p className='c74 mb1rem'>Go beyond standard financial reporting. Our AI-driven <span className='fw600'> Healthboost™ modules</span> and <br></br> <span className='fw600'>AnyList™ checklists</span> provide a structured playbook to systematically improve your<br></br> client's revenues, margins, and processes. </p>

                <p className='c74'>This enables you to: </p>
                <ul
                    style={{
                        listStyleType: 'disc',
                        paddingLeft: '20px'
                    }}
                >
                    <li className='c74'> <span className='fw600'> Demonstrate value instantly </span>  with data-driven insights. </li>
                    <li className='c74'> <span className='fw600'>Create long-term engagements</span> through structured quarterly reviews.</li>
                    <li className='c74'> <span className='fw600'>Expand your remit </span> and become a true C-suite advisor. </li>
                </ul>
            </>,
            author: 'AW, CFOC Fractional CFO',
        },
        'maximise': {
            title: <h3 className='fs1-5rem c15 fw600'>An Exit Defines Your Client's Legacy - <br></br> and Your Reputation</h3>,
            testimonial: `You could walk into any assignment and start at 60% rather than zero`,
            description: <>
                <p className='c74 mb1rem'>Whether you're planning a long-term exit strategy or responding to an unexpected<br></br>
                    offer, Diligentsia provides the structured playbook to get your client ready. Our<br></br>
                    platform ensures you're always prepared to maximize value and present a credible, <br></br>
                    pre-diligenced opportunity to buyers.
                </p>
                <p className='c74'>Our platform helps you: </p>
                <ul
                    style={{
                        listStyleType: 'disc',
                        paddingLeft: '20px'
                    }}
                >
                    <li className='c74'>Achieve a perpetual  <span className='fw600'> "near exit-ready state" </span> for all your clients. </li>
                    <li className='c74'> <span className='fw600 mr0-25rem'>Increase buyer interest</span> with a professional diligence pack. </li>
                    <li className='c74'> <span className='fw600'>Aim for a +10% uplift </span> in the final exit value.</li>
                </ul>
            </>,
            author: 'RD, Fractional CFO',
        }
    }
    return (
        <>
            <ModalWrapper
                modalType={'fractionHelpClient'}
                modalCardClasses='maw1200px fractionHelpClientModal'
                customStyle={{ padding: helpClientModal === "systematically" || "maximise" === helpClientModal ? "3rem 2rem 5rem" : '3rem 2rem' }}
            >

                <div className='df aic h100' style={{ minHeight: '440px' }}>
                    <div className='pl2rem' style={{ width: '65%' }}>
                        <div className='df aic mb1rem'>
                            <img width={90} height={90} src={image} alt='helpClientModal' />
                            {data[helpClientModal].title}
                        </div>
                        <div className='pl1rem'>{data[helpClientModal].description}</div>
                    </div>
                    <div className='w30 pr' style={{ minHeight: '420px', width: '35%' }}>
                        <img className={"maximise" === helpClientModal ? 'w90 mt2rem' : 'w100 pr'} src={rightImage} alt='helpClientModal' />
                        <div
                            className='br8px p2rem mt1rem pa'
                            style={{
                                backgroundColor: `rgba(229, 233, 254, 0.4)`,
                                bottom: "maximise" === helpClientModal ? '0px' : '-30px',
                                left: '0px',
                                backdropFilter: 'blur(8px)',
                                WebkitBackdropFilter: 'blur(8px)'
                            }}
                        >
                            <img width={18} height={18} src={require('../../../../images/fractional/helpClient/Icon-pack.png')} alt='helpClient' />
                            <span className='c15 ml0-5rem fw600 fsi' style={{ fontSize: '20px' }}>{data[helpClientModal].testimonial}</span>
                            <div className='df aic'>
                                <span className='c15 fs14px mr0-5rem'>{data[helpClientModal].author}</span>
                                {/* <img src={require('../../../../images/fractional/helpClient/five-star.svg')} alt='helpClient' /> */}
                            </div>
                        </div>
                    </div>


                </div>

            </ModalWrapper>
        </>
    )
}

export default FractionHelpClientModal